let currencyCode = $(".gtm-data").attr("data-currency");

// extracts the numeric price from a price ".value" element.
// Some price templates render the value only in the "content" attribute
// (empty text node), so the attribute takes precedence over the text.
function getPriceValue($scope, selector) {
    const $element = $scope.find(selector).not(".strike-through").first();
    if (!$element.length) {
        return 0;
    }

    let contentValue = Number($element.attr("content"));
    if (!isNaN(contentValue) && contentValue > 0) {
        return contentValue;
    }

    let textValue = $element.text().trim().replace(/[^\d]/g, "");
    return Number(textValue) || 0;
}

// triggers page_view event
function pageViewEvent() {
    const $gtmData = $(".gtm-data");
    let userType = $gtmData.attr("data-customer") === "true" ? "Registered" : "Guest";
    let language = $gtmData.attr("data-language").toUpperCase();
    let pageTitle = document.title;
    let pageLocation = window.location.href;
    let userID = $gtmData.attr("data-customer-id") ? $gtmData.attr("data-customer-id") : "";
    window.dataLayer &&
    window.dataLayer.push({
        "event": "page_view",
        "user_id": userID,
        "user_type": userType,
        "site_language": language,
        "page_title": pageTitle,
        "page_location": pageLocation
    });
}

// triggers select_item event
function selectItem(element) {
    const $productTile = $(element);
    let productID = $productTile.attr("data-pid");
    let productBrand = $productTile.find(".product-tile-brand .link").text().trim();
    let productName = $productTile.find(".pdp-link .link").text().trim();
    let productPrice = getPriceValue($productTile, ".price .value");
    let productCategoryList = $productTile.attr("data-categories").split(",");

    let item = {
        "item_name": productName,
        "item_id": productID,
        "price": productPrice,
        "item_brand": productBrand,
        "quantity": 1,
        "index": 0
    };

    let newItem = appendCategories(item, productCategoryList);

    window.dataLayer &&
    window.dataLayer.push({
        "event": "select_item",
        "ecommerce": {
            "currency": currencyCode,
            "value": productPrice,
            "items": [newItem]
        }
    });
}

// triggers view_item event
function viewItem() {
    const $product = $(".product-detail");
    const $productDetails = $product.find(".product-details-section");
    let productID = $product.attr("data-pid");
    let productBrand = $productDetails.find(".brand").text().trim() || $productDetails.find(".manufacturer-name").text().trim();
    let productName = $productDetails.find(".product-name").text().trim();
    let productPrice = getPriceValue($productDetails, ".sales .value") || getPriceValue($productDetails, ".prices .value");
    let productCategoryList = $productDetails.find(".gtm-categories").text().trim().split(",");
    let item = {
        "item_name": productName,
        "item_id": productID,
        "price": productPrice,
        "item_brand": productBrand,
        "quantity": 1,
        "index": 0
    };

    let newItem = appendCategories(item, productCategoryList);

    window.dataLayer &&
    window.dataLayer.push({
        "event": "view_item",
        "ecommerce": {
            "currency": currencyCode,
            "value": productPrice,
            "items": [newItem]
        }
    });
}

// triggers view_item_list event
function viewItemList(element, startValue) {
    const $productTile = startValue ? $(element).find(".product-tile:gt(" + startValue + ")") : $(element).find(".product-tile");
    const batchSize = 20;
    var objects = [];

    $productTile.each(function (index) {
        let productID = $(this).attr("data-pid");
        let productBrand = $(this).find(".product-tile-brand .link").text().trim();
        let productName = $(this).find(".pdp-link .link").text().trim();
        let productPrice = getPriceValue($(this), ".price .value");

        const item = {
            "item_name": productName,
            "item_id": productID,
            "price": productPrice,
            "brand": productBrand,
            "quantity": 1,
            "index": index
        };

        let productCategoryList = $(this).attr("data-categories").split(",");
        let newItem = appendCategories(item, productCategoryList);

        objects.push(newItem);

        if (objects.length === batchSize) {
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                "event": "view_item_list",
                "ecommerce": {
                    "currency": currencyCode,
                    "items": objects
                }
            });
            objects = [];
        }
    });

    if (objects.length > 0) {
        window.dataLayer &&
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            "event": "view_item_list",
            "ecommerce": {
                "currency": currencyCode,
                "items": objects
            }
        });
    }
}

// triggers add_to_cart event
function addToCart(element, productType, quantity, isMinicart) {
    const $product = $(element);
    const $productDetails = $product.find(".product-details-section");
    let productID, productBrand, productName, productPrice, productQuantity, productCategoryList, totalValue;
    switch (productType) {
        case "ahumadaFamilyProductPromotion":
            productID = $product.data("data-pid");
            productBrand = $product.data("product-brand");
            productName = $product.data("product-name");
            productPrice = Number($product.data("product-price"));
            productQuantity = 1;
            productCategoryList = $product.data("categories").split(",");
            totalValue = productPrice;
            break;
        case "tile":
            productID = $product.attr("data-pid");
            productBrand = $product.find(".product-tile-brand .link").text().trim();
            productName = $product.find(".pdp-link .link").text().trim();
            productPrice = getPriceValue($product, ".price .value");
            productQuantity = 1;
            productCategoryList = $product.attr("data-categories").split(",");
            totalValue = productPrice;
            break;
        case "detail":
            productID = $product.attr("data-pid");
            productBrand = $productDetails.find(".brand").text().trim() || $productDetails.find(".manufacturer-name").text().trim();
            productName = $productDetails.find(".product-name").text().trim();
            productPrice = getPriceValue($productDetails, ".sales .value") || getPriceValue($productDetails, ".prices .value");
            productQuantity = Number($productDetails.find(".quantity-select").val());
            productCategoryList = $productDetails.find(".gtm-categories").text().trim().split(",");
            totalValue = productPrice * productQuantity;
            break;
        case "cart":
            if (isMinicart) {
                productID = $product.attr("data-pid");
                productBrand = $product.attr("data-brand");
                productName = $product.find(".line-item-name span").text().trim();
                productPrice = getPriceValue($product, ".sales .value");
                productCategoryList = $product.attr("data-categories").split(",");
            } else {
                productID = $product.attr("data-pid");
                productBrand = $product.attr("data-brand");
                productName = $product.find(".line-item-product-name").text().trim();
                productPrice = getPriceValue($product, ".sales .value");
                productCategoryList = $product.attr("data-categories").split(",");
            }
            productQuantity = Number(quantity);
            totalValue = productPrice * productQuantity;
            break;
        default:
            break;
    }
    let item = {
        "item_name": productName,
        "item_id": productID,
        "price": productPrice,
        "item_brand": productBrand,
        "quantity": productQuantity,
        "index": 0
    };

    let newItem = appendCategories(item, productCategoryList);

    window.dataLayer &&
    window.dataLayer.push({
        "event": "add_to_cart",
        "ecommerce": {
            "currency": currencyCode,
            "value": totalValue,
            "items": [newItem]
        }
    });
}

// triggers add_to_cart event
function removeFromCart(element, quantity, isMinicart) {
    const $product = $(element);
    let productID, productBrand, productName, productPrice, productQuantity, productCategoryList, totalValue;
    if (isMinicart) {
        productID = $product.attr("data-pid");
        productBrand = $product.attr("data-brand");
        productName = $product.find(".line-item-name span").text().trim();
        productPrice = getPriceValue($product, ".sales .value");
        productCategoryList = $product.attr("data-categories").split(",");
    } else {
        productID = $product.attr("data-pid");
        productBrand = $product.attr("data-brand");
        productName = $product.find(".line-item-product-name").text().trim();
        productPrice = getPriceValue($product, ".sales .value");
        productCategoryList = $product.attr("data-categories").split(",");
    }
    productQuantity = Number(quantity);
    totalValue = productPrice * productQuantity;

    let item = {
        "item_name": productName,
        "item_id": productID,
        "price": productPrice,
        "item_brand": productBrand,
        "quantity": productQuantity,
        "index": 0
    };

    let newItem = appendCategories(item, productCategoryList);

    window.dataLayer &&
    window.dataLayer.push({
        "event": "remove_from_cart",
        "ecommerce": {
            "currency": currencyCode,
            "value": totalValue,
            "items": [newItem]
        }
    });
}

// triggers view_cart event
function viewCart() {
    const $products = $(".product-info");
    const basketValue = Number($(".grand-total").text().trim().substring(1).replace(".", ""));
    var objects = [];

    if ($products.length) {
        $products.each(function (index) {
            let productID = $(this).attr("data-pid");
            let productBrand = $(this).attr("data-brand");
            let productName = $(this).find(".line-item-product-name").text().trim();
            let productPrice = getPriceValue($(this), ".sales .value");
            let productCategoryList = $(this).attr("data-categories").split(",");
            let productQuantity = Number($(this).find(".quantity.custom-select").val());

            const item = {
                "item_name": productName,
                "item_id": productID,
                "price": productPrice,
                "brand": productBrand,
                "quantity": productQuantity,
                "index": index
            };

            let newItem = appendCategories(item, productCategoryList);
            objects.push(newItem);
        });

        window.dataLayer &&
        window.dataLayer.push({
            "event": "view_cart",
            "ecommerce": {
                "currency": currencyCode,
                "value": basketValue,
                "items": objects
            }
        });
    }
}

// Used to trigger begin_checkout, add_shipping_info and add_payment_info event
function checkoutEvents(label) {
    const $products = $(".product-summary-block .product-line-item");
    const basketValue = Number($(".grand-total-sum").first().text().trim().substring(1).replace(".", ""));
    var objects = [];

    $products.each(function (index) {
        let productID = $(this).attr("data-pid");
        let productBrand = $(this).attr("data-brand");
        let productName = $(this).find(".line-item-name span").text().trim();
        let productPrice = getPriceValue($(this), ".sales .value") || getPriceValue($(this), ".price .value");
        let productCategoryList = $(this).attr("data-categories").split(",");
        let productQuantity = Number($(this).find(".qty-card-quantity-count").text().trim());

        const item = {
            "item_name": productName,
            "item_id": productID,
            "price": productPrice,
            "brand": productBrand,
            "quantity": productQuantity,
            "index": index
        };

        let newItem = appendCategories(item, productCategoryList);
        objects.push(newItem);
    });

    var ecommerceObject = {
        "currency": currencyCode,
        "value": basketValue,
        "items": objects
    };

    switch (label) {
        case "add_shipping_info":
            ecommerceObject["shipping_tier"] = $(".shipping-method-block .delivery-type-container.active").first().find(".custom-control-label").text().trim();
            break;
        case "add_payment_info":
            ecommerceObject["payment_type"] = $(".ahumada-custom-radio.selected").first().closest(".payment-methos-accordion-header").attr("id");
            break;
        case "purchase":
            ecommerceObject["transaction_id"] = $(".summary-details.order-number").text().trim();
            ecommerceObject["shipping"] = $(".shipping-method-title").text().trim();
            ecommerceObject["payment"] = $(".credit-card-type span").text().trim();
            break;
        default:
            break;
    }

    window.dataLayer &&
    window.dataLayer.push({
        "event": label,
        "ecommerce": ecommerceObject
    });
}

// triggers sign_up event
function gtmSignUp() {
    window.dataLayer &&
    window.dataLayer.push({
        "event": "sign_up",
        "method": "Email"
    });
}

// triggers sign_up event
function gtmLogin() {
    window.dataLayer &&
    window.dataLayer.push({
        "event": "login",
        "method": "Email"
    });
}

// triggers search event
function gtmSearch() {
    const resultsCount = $(".search-result-count").attr("data-results-count");
    const searchQuery = $(".search-result-for").attr("data-search-query");

    window.dataLayer &&
    window.dataLayer.push({
        "event": "search",
        "search_term": searchQuery,
        "search_results": Number(resultsCount)
    });
}

// adds the categories to the item object (GA4 only supports item_category..item_category5)
function appendCategories(item, productCategoryList) {
    const maxCategories = 5;
    const categories = (productCategoryList || []).map(function (category) {
        return category.trim();
    }).filter(function (category) {
        return category.length > 0;
    }).slice(0, maxCategories);

    for (let j = 0; j < categories.length; j++) {
        if (j === 0) {
            item.item_category = categories[j];
        } else {
            item["item_category" + (j + 1)] = categories[j].replace(/'/g, "");
        }
    }

    return item;
}

module.exports.pageViewEvent = pageViewEvent;
module.exports.selectItem = selectItem;
module.exports.viewItem = viewItem;
module.exports.viewItemList = viewItemList;
module.exports.addToCart = addToCart;
module.exports.viewCart = viewCart;
module.exports.removeFromCart = removeFromCart;
module.exports.gtmSearch = gtmSearch;
module.exports.gtmSignUp = gtmSignUp;
module.exports.gtmLogin = gtmLogin;
module.exports.checkoutEvents = checkoutEvents;
